<template>
    <div class="w-full px-2 bg-healthcare text-white" :style="'background-color: ' + form.background_colour + ';'">
        <div class="h-20 flex ">
            <img class="mx-auto h-20" :src="s3URL + '/' + form.icon_url" alt="">
        </div>
        <h3 class="mt-3 text-center text-md min-h-24">{{ form.name }}</h3>
        <div class="flex justify-between flex-wrap mt-2">
            <h6>Limit</h6>
            <h6 v-if="form.limit > 0">${{ form.limit.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</h6>
            <h6 v-else>N/A</h6>
        </div>
        <div class="flex justify-between flex-wrap mt-3">
            <h6>Remaining</h6>
            <h6 v-if="form.limit > 0">${{ form.values.remaining.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</h6>
            <h6 v-else>N/A</h6>
        </div>
        <div class="flex justify-between py-3 items-center mt-3">
            <h6 id="healthcareFaqOpen" class="cursor-pointer" @click="openFAQs($event)" v-if="form.faqs && form.faqs.length > 0">FAQ'S</h6>
            <router-link :to="'/applications/new/' + form.id + '/' + applicant"
                class="flex w-12 h-12 justify-center items-center bg-white rounded-full border-2 border-white cursor-pointer text-gray-600"
                v-if="(form.values.remaining > 0 || form.limit === 0) && (!form.remaining_threshold || form.values.remaining >= form.remaining_threshold)"
            >
                GO
            </router-link>
        </div>
        <div class="transition-all duration-300 ease-in-out absolute left-0 right-0 bg-white p-2 h-full max-w-screen-mobile" v-if="showFAQs">
            <div class="flex justify-between items-center">
                <div class="font-bold text-black text-2xl">FAQ's</div>
                <div id="healthcareFaqClose" class="w-32 p-3 bg-secondary text-center text-white font-bold rounded-sm cursor-pointer" @click="showFAQs = false">CLOSE</div>
            </div>
            <div class="pb-4">
                <div class="mt-4 text-black" v-for="(faq, FAQIndex) in form.faqs" :key="FAQIndex">
                    <div class="font-bold">Q: {{ faq.question }} </div>
                    <div class="mt-1 font-normal">A: {{ faq.answer }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'

export default {
    name: 'ApplicationFormCard',
    props: {
        form: {
            type: Object,
            required: true
        },
        applicant: {
            default: ''
        }
    },
    setup () {
        const s3URL = process.env.VUE_APP_S3_URL
        const showFAQs = ref(false)

        function openFAQs (event) {
            showFAQs.value = true
            setTimeout(() => {
                event.target.parentElement.scrollIntoView()
            }, 100)
        }

        return {
            s3URL,
            showFAQs,
            openFAQs
        }
    }
}
</script>
